var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-label",style:({ background: _vm.bgColor, width: _vm.width })},[_vm._v(" "+_vm._s(_vm.status)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }